/* eslint-disable max-len */
import browserHistory from '../../exceed/helpers/getHistory';

const urlSearchFactory = ({ history = browserHistory, search } = {}) => ({
  appendValue(key, value) {
    const urlParams = this.getParams();

    const existingValues = urlParams.getAll(key);
    const existingValueIndex = existingValues.findIndex(
      (existingValue) => existingValue === String(value),
    );
    const isExistingValue = existingValueIndex >= 0;

    if (isExistingValue) {
      existingValues.splice(existingValueIndex, 1);
      urlParams.delete(key);
      existingValues.forEach((existingValue) => urlParams.append(key, existingValue));
    } else {
      urlParams.append(key, value);
    }

    return this.applyParams(urlParams);
  },
  applyParams(params) {
    history.push(`${this.getPathname()}?${params.toString()}`);

    return params;
  },
  deleteValue(key) {
    const urlParams = this.getParams();

    const existingValue = urlParams.get(key);

    if (existingValue) {
      urlParams.delete(key);

      return this.applyParams(urlParams);
    }
  },
  getParams(customSearch) {
    return new URLSearchParams(customSearch || search || window.location.search);
  },
  getPathname() {
    const { location } = window;
    return location.pathname;
  },
  getValue(key) {
    const urlParams = this.getParams();

    return urlParams.get(key);
  },
  getValues(key) {
    const urlParams = this.getParams();

    return urlParams.getAll(key);
  },
  setValue(key, value) {
    const urlParams = this.getParams();

    const existingValues = urlParams.getAll(key);
    const existingValueIndex = existingValues.findIndex(
      (existingValue) => existingValue === String(value),
    );
    const isExistingValue = existingValueIndex >= 0;

    if (isExistingValue) {
      urlParams.delete(key);
    } else {
      urlParams.set(key, value);
    }

    return this.applyParams(urlParams);
  },
});

export default urlSearchFactory();
export { urlSearchFactory };
